export const EMISSION_SIGNED = 100;

export default EMISSION_SIGNED;
